import { ReactNode } from "react";
import { AuthThemeProvider } from "@/context/AuthThemeContext";

interface AuthThemeWrapperProps {
  children: ReactNode;
}

const AuthThemeWrapper = ({ children }: AuthThemeWrapperProps) => {
  return (
    <AuthThemeProvider>
      {children}
    </AuthThemeProvider>
  );
};

export default AuthThemeWrapper; 